import { ApplicationConfigurationCustomQuestion } from '@zg-rentals/ts-capps-client';

export type FinancialContactType = {
  question: ApplicationConfigurationCustomQuestion;
  fieldName: 'accountantContact' | 'attorneyContact' | 'brokerageContact';
  label: string;
  nameLabel: string;
};

export const FINANCIAL_CONTACT_TYPES: Array<FinancialContactType> = [
  {
    question: ApplicationConfigurationCustomQuestion.ACCOUNTANT_CONTACT,
    fieldName: 'accountantContact',
    label: 'Accountant',
    nameLabel: 'Full name',
  },
  {
    question: ApplicationConfigurationCustomQuestion.ATTORNEY_CONTACT,
    fieldName: 'attorneyContact',
    label: 'Attorney',
    nameLabel: 'Full name',
  },
  {
    question: ApplicationConfigurationCustomQuestion.BROKERAGE_CONTACT,
    fieldName: 'brokerageContact',
    label: 'Brokerage account',
    nameLabel: 'Institution name',
  },
];
